import React, { useCallback } from 'react';

import Link from '@atlaskit/link/link';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE } from '../../controller/shareAndRestrictDialogConfig.ts';

const SAC_LEARN_MORE_DOCUMENTATION =
	'https://support.atlassian.com/confluence-cloud/docs/troubleshoot-access-problems-to-content/';

export const LearnMoreChunk = (chunks: React.ReactNode[]) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleClick = useCallback(() => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE,
				action: 'clicked',
				actionSubject: 'link',
				actionSubjectId: 'blockedAccessLearnMore',
			},
		}).fire();
	}, [createAnalyticsEvent]);

	return (
		<Link target="_blank" href={SAC_LEARN_MORE_DOCUMENTATION} onClick={handleClick}>
			{chunks}
		</Link>
	);
};
